import { Directive } from '@angular/core';

@Directive({
  selector: 'button[tuiOption][woDestructive]',
  standalone: true,
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: {
    class: 'iss-destructive-button',
  },
})
export class DestructiveOptionDirective {}
